import type { SideNavigationItem, SideNavigationLink } from '@vendasta/protos/atlas/v1/types';

/** Every link in the tree, depth first, sub-links after their parent. */
export function flattenNavigationLinks(items: SideNavigationItem[]): SideNavigationLink[] {
  return items.reduce<SideNavigationLink[]>((acc, item) => {
    if (item.sideNavigationContainer) {
      acc.push(...flattenNavigationLinks(item.sideNavigationContainer.sideNavigationItems));
    }
    if (item.sideNavigationLink) {
      acc.push(item.sideNavigationLink);
      acc.push(...(item.sideNavigationLink.subLinks || []));
    }
    return acc;
  }, []);
}
